import { caseDetailHref } from '../MemberCompliancePanels'

import { formatSydneyDate } from '../../../../utils/sydneyDateTime'
function ts(value) {
  const t = new Date(value || 0).getTime()
  return Number.isFinite(t) ? t : 0
}

function shortDate(value) {
  if (!value) return '—'
  try {
    return formatSydneyDate(new Date(value))
  } catch {
    return String(value)
  }
}

export function buildComplianceTimeline({
  kycEntries = [],
  amlChecks = [],
  caseHistory = [],
  incidents = [],
  monitorAlerts = [],
}) {
  const events = []

  for (const k of kycEntries) {
    const failed = String(k.dvs_status || k.dvs_result || k.outcome || '').toUpperCase().includes('FAIL')
    events.push({
      id: `kyc-${k.id}`,
      category: 'kyc',
      label: 'KYC',
      title: `#${k.id} ${failed ? 'failed' : 'verified'} · ${String(k.reason || 'KYC').replace(/_/g, ' ')}`,
      at: k.performed_at || k.created_at,
      sortKey: ts(k.performed_at || k.created_at),
    })
  }

  for (const c of amlChecks) {
    const confirmed = c.analyst_decision === 'confirmed_match'
    const noMatch = c.analyst_decision === 'no_match'
    const clear = Number(c.result_count) === 0
    let title = c.reason || 'AML/PEP screen'
    if (confirmed) title = `Confirmed match · ${c.aml_derived_category || 'review'}`
    else if (noMatch) title = `Reviewed as no match · ${c.analyst_reason || c.reason || ''}`.trim()
    else if (clear) title = 'Screen clear · no match'
    else if (c.result_count) title = `${c.result_count} result(s) · ${c.reason || 'review'}`
    events.push({
      id: `aml-${c.id}`,
      category: 'screening',
      label: 'Screening',
      title,
      at: c.created_at,
      sortKey: ts(c.created_at),
      amlCheckId: c.id,
    })
  }

  for (const c of caseHistory) {
    const href = caseDetailHref(c)
    const open = String(c.status || '').toLowerCase() !== 'closed' && String(c.status || '').toLowerCase() !== 'filed'
    events.push({
      id: `case-${c.id}`,
      category: 'investigations',
      label: 'Investigation',
      title: `${c.case_number || c.id} · ${c.case_type || 'case'}${open ? ' (open)' : ''}`,
      at: c.updated_at || c.created_at,
      sortKey: ts(c.updated_at || c.created_at),
      href,
    })
  }

  for (const inc of incidents) {
    events.push({
      id: `inc-${inc.id}`,
      category: 'uar',
      label: 'UAR',
      title: inc.incident_type ? String(inc.incident_type).replace(/_/g, ' ') : 'Incident report',
      at: inc.created_at || inc.reported_at,
      sortKey: ts(inc.created_at || inc.reported_at),
    })
  }

  for (const a of monitorAlerts) {
    events.push({
      id: `alert-${a.id}`,
      category: 'alerts',
      label: 'Alert',
      title: a.alert_type || a.title || 'Monitoring alert',
      at: a.last_updated || a.first_seen || a.created_at,
      sortKey: ts(a.last_updated || a.first_seen || a.created_at),
    })
  }

  events.sort((a, b) => b.sortKey - a.sortKey)
  return events.map((e) => ({ ...e, when: shortDate(e.at) }))
}

export function timelineFilterCounts(events) {
  const counts = { all: events.length, kyc: 0, screening: 0, investigations: 0, uar: 0, alerts: 0 }
  for (const e of events) {
    if (counts[e.category] != null) counts[e.category] += 1
  }
  return counts
}
